import resolveConfig from "tailwindcss/resolveConfig";

import tailwindConfig from "../../tailwind.config";

// Resolved once per module lifetime: resolveConfig deep-clones and merges the whole default theme (~100ms of main-thread work on a throttled machine), and the config never changes at runtime. Before this cache every render of a caller such as getSizesString paid that price again, which is what made a TTV undo take a second once the voice picker rendered one image per singer.
let resolvedConfig: ReturnType<
  typeof resolveConfig<typeof tailwindConfig>
> | null = null;

export const getTailwindConfig = () => {
  if (resolvedConfig === null) {
    resolvedConfig = resolveConfig(tailwindConfig);
  }
  return resolvedConfig;
};
